module.exports = __webpack_public_path__ + "img/home-high-1.fd5c9c84.png";